import CancellationMessage from './CancellationMessage';

export default CancellationMessage;
